/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ButtonProps, Tooltip } from "@nordcloud/gnui";
import { InlineActionButton } from "~/components/Styled/InlineActionButton";

export function EditButton({ onClick }: ButtonProps) {
  return (
    <Tooltip status="notification" caption="Edit" hideTimeout={0}>
      <InlineActionButton
        severity="low"
        size="sm"
        icon="edit"
        aria-pressed="false"
        onClick={onClick}
        data-cy="edit-button"
      />
    </Tooltip>
  );
}
